import React from 'react';
import { Box, Button } from '@mui/material';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import theme from 'theme';

interface CounterProps {
  min?: number;
  max?: number;
  value: number;
  onChange: (value: number) => void;
}

const Counter = ({ value, onChange, min, max }: CounterProps) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <Button
      sx={{
        padding: 0,
        minWidth: 'auto',
        background: theme.palette.grey[50],
        '&.Mui-disabled': {
          background: theme.palette.grey[600],
        },

        color: theme.palette.grey[900],
        borderRadius: '50%',
        '&:hover ': {
          background: theme.palette.grey[50],
          opacity: 0.7,
        },
      }}
      disabled={value === min}
      onClick={() => onChange(value - 1)}
    >
      <RemoveIcon sx={{ fontSize: 20 }} />
    </Button>
    <Box
      sx={{
        fontSize: 14,
        margin: theme.spacing(0, 1),
      }}
    >
      {value}
    </Box>
    <Button
      sx={{
        padding: 0,
        minWidth: 'auto',
        background: theme.palette.grey[50],
        '&.Mui-disabled': {
          background: theme.palette.grey[600],
        },

        color: theme.palette.grey[900],
        borderRadius: '50%',
        '&:hover ': {
          background: theme.palette.grey[50],
          opacity: 0.7,
        },
      }}
      disabled={value === max}
      onClick={() => onChange(value + 1)}
    >
      <AddIcon sx={{ fontSize: 20 }} />
    </Button>
  </Box>
);

export default Counter;
